export default __webpack_public_path__ + "0bc975ca25aea8298fc8dc3f6501a4ea.svg";